
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("egyYq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "EndOfTrialExtension", () => $5328e189f571ca5d$export$247b969e5bf0820b);
$parcel$export(module.exports, "default", () => $5328e189f571ca5d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $lpwtK = parcelRequire("lpwtK");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $5oBMG = parcelRequire("5oBMG");

var $jkADf = parcelRequire("jkADf");

var $6R7U7 = parcelRequire("6R7U7");

var $irRG1 = parcelRequire("irRG1");
const $5328e189f571ca5d$export$247b969e5bf0820b = ()=>{
    const { data: project } = (0, $lpwtK.useProject)();
    const projectType = (0, $2vSU6.toProjectType)(project?.type);
    const appEditions = (0, $k9JTq.useAppEditions)();
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const productKey = projectType && (0, $2vSU6.projectTypeToCanonicalId)(projectType);
    const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
    const billingSourceSystem = entitlementDetails?.billingSourceSystem;
    const trialDaysLeft = (0, $6R7U7.useTrialDaysLeft)(entitlementDetails?.trialEndTime);
    const shouldLoadEntryPoint = (0, $6R7U7.isProjectTypeAndEditionSupported)(appEditions, project?.type) && billingSourceSystem === 'CCP' && (0, $6R7U7.isStartOfTrial)(trialDaysLeft);
    const { entryPointReferenceSubject: entryPointReferenceSubject } = $5328e189f571ca5d$var$useCoordinatorEntryPoint(shouldLoadEntryPoint);
    if (!shouldLoadEntryPoint) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jkADf.ContextWrapper), {
        attributes: {
            trialDaysLeft: trialDaysLeft,
            growthInitiative: 'buy'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "growth.endOfTrialExtension.coordinator",
        packageName: "jira-end-of-trial-extension",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: {
            trialDaysLeft: trialDaysLeft
        }
    }));
};
var $5328e189f571ca5d$export$2e2bcd8739ae039 = $5328e189f571ca5d$export$247b969e5bf0820b;
const $5328e189f571ca5d$var$useCoordinatorEntryPoint = (shouldLoad)=>{
    const cloudID = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudID
        }), [
        cloudID
    ]);
    const hasLoadedEntrypoint = (0, $5uXOq.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $irRG1.endOfTrialExtensionCoordinatorEntryPoint), entryPointParams);
    if (!hasLoadedEntrypoint.current && shouldLoad) {
        entryPointActions.load();
        hasLoadedEntrypoint.current = true;
    }
    return {
        entryPointReferenceSubject: entryPointReferenceSubject
    };
};

});
parcelRegister("jkADf", function(module, exports) {

$parcel$export(module.exports, "ContextWrapper", () => $e64f0f96877c6709$export$34282a1f95511a11);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cjFoH = parcelRequire("cjFoH");

var $9xWGk = parcelRequire("9xWGk");

var $daJ0i = parcelRequire("daJ0i");
const $e64f0f96877c6709$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))));
};
const $e64f0f96877c6709$export$34282a1f95511a11 = (props)=>{
    const data = $e64f0f96877c6709$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: data,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: props.children
        })
    });
};

});

parcelRegister("6R7U7", function(module, exports) {

$parcel$export(module.exports, "isProjectTypeAndEditionSupported", () => $0dabfd3b020955d9$export$c9a5a2a3868318aa);
$parcel$export(module.exports, "useTrialDaysLeft", () => $0dabfd3b020955d9$export$4b4eb19be6ec09df);
$parcel$export(module.exports, "isStartOfTrial", () => $0dabfd3b020955d9$export$3ed802a9182778d3);
$parcel$export(module.exports, "getEpMessageId", () => $0dabfd3b020955d9$export$6d238e51ec3581ff);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $ldyPw = parcelRequire("ldyPw");
const $0dabfd3b020955d9$export$c9a5a2a3868318aa = (applicationEditions, project)=>{
    const projectType = (0, $2vSU6.toProjectType)(project);
    if (!projectType || projectType !== (0, $2vSU6.SOFTWARE_PROJECT)) return false;
    return applicationEditions.software === (0, $ldyPw.STANDARD_EDITION);
};
const $0dabfd3b020955d9$var$getStartOfUTCDay = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
const $0dabfd3b020955d9$var$getTrialDaysLeft = (currentDate, trialEndTime)=>trialEndTime ? Math.ceil(($0dabfd3b020955d9$var$getStartOfUTCDay(trialEndTime) - currentDate) / 86400000) : undefined;
const $0dabfd3b020955d9$export$4b4eb19be6ec09df = (trialEndTime)=>{
    const currentDate = (0, $5uXOq.useMemo)(()=>Date.now(), []);
    const trialDaysLeft = $0dabfd3b020955d9$var$getTrialDaysLeft(currentDate, trialEndTime) ?? 0;
    return trialDaysLeft;
};
const $0dabfd3b020955d9$export$3ed802a9182778d3 = (daysLeft)=>daysLeft >= 8 && daysLeft <= 13;
const $0dabfd3b020955d9$export$6d238e51ec3581ff = (daysLeft)=>{
    if (daysLeft >= 11 && daysLeft <= 13) return 'prj-end-of-trial-extension-message-1';
    if (daysLeft >= 8 && daysLeft <= 10) return 'prj-end-of-trial-extension-message-2';
    return null;
};

});

parcelRegister("irRG1", function(module, exports) {

$parcel$export(module.exports, "endOfTrialExtensionCoordinatorEntryPoint", () => $4771212f0ac266b7$export$a9d3ae8f5b103f);

var $jPRjl = parcelRequire("jPRjl");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $4771212f0ac266b7$export$a9d3ae8f5b103f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("cyvNE")), {
        moduleId: "52e3b20a"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            entryPoints: {},
            queries: {
                billingAdminQuery: {
                    parameters: (0, $jPRjl.default),
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("jPRjl", function(module, exports) {

$parcel$export(module.exports, "default", () => $85e7f93a33135f02$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f816225c59f1fde69d9ed3fe14c13045>>
 * @relayHash 3d4e870877dd2a0bda363283a8a6a8ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 40c541d31e88e1e53728ce697e7615b9cb264308bd85d7540f3d457daa32b191
const $85e7f93a33135f02$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "40c541d31e88e1e53728ce697e7615b9cb264308bd85d7540f3d457daa32b191",
        "metadata": {},
        "name": "uiExperimentCoordinatorEndOfTrialExtensionQuery",
        "operationKind": "query",
        "text": null
    }
};
var $85e7f93a33135f02$export$2e2bcd8739ae039 = $85e7f93a33135f02$var$node;

});

parcelRegister("cyvNE", function(module, exports) {

let $924153d0980a4ad1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $924153d0980a4ad1$var$load("kZswe").then(()=>parcelRequire('fuHn4'));

});




//# sourceMappingURL=end-of-trial-extension.605f52a2.js.map
